import React from 'react';
import { Clock3, AlertTriangle } from 'lucide-react';

// Маленький переиспользуемый бэйдж «истекает через N дней / N часов».
// Принимает ISO-дату expiresAt и (опционально) status — чтобы корректно
// отрисовать просроченный или удалённый квиз без падения.
const fmt = (ms) => {
  const minutes = Math.floor(ms / 60000);
  if (minutes < 60) return `${minutes} мин`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `${hours} ч`;
  const days = Math.floor(hours / 24);
  return `${days} дн`;
};

const ExpirationBadge = ({ expiresAt, status, className = '' }) => {
  if (!expiresAt) return null;

  if (status === 'expired') {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1 text-xs font-medium text-gray-600 dark:text-gray-400 ${className}`}>
        <Clock3 className="w-3.5 h-3.5" />
        Истёк
      </span>
    );
  }

  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full bg-gray-100 dark:bg-gray-800 px-2.5 py-1 text-xs font-medium text-gray-600 dark:text-gray-400 ${className}`}>
        <Clock3 className="w-3.5 h-3.5" />
        Истёк
      </span>
    );
  }

  // Последние 24 часа — красный «warning».
  const critical = ms < 24 * 3600 * 1000;
  const cls = critical
    ? 'bg-red-50 dark:bg-red-950/30 text-red-700 dark:text-red-300'
    : 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-700 dark:text-emerald-300';
  const Icon = critical ? AlertTriangle : Clock3;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${cls} ${className}`}>
      <Icon className="w-3.5 h-3.5" />
      Осталось {fmt(ms)}
    </span>
  );
};

export default ExpirationBadge;
